var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/camera"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.76017 22.9412H17.2402C20.0002 22.9412 21.1002 21.2512 21.2302 19.1912L21.7502 10.9312C21.8902 8.77116 20.1702 6.94116 18.0002 6.94116C17.3902 6.94116 16.8302 6.59116 16.5502 6.05116L15.8302 4.60116C15.3702 3.69116 14.1702 2.94116 13.1502 2.94116H10.8602C9.83017 2.94116 8.63017 3.69116 8.17017 4.60116L7.45017 6.05116C7.17017 6.59116 6.61017 6.94116 6.00017 6.94116C3.83017 6.94116 2.11017 8.77116 2.25017 10.9312L2.77017 19.1912C2.89017 21.2512 4.00017 22.9412 6.76017 22.9412Z",
    stroke: "#E8E8E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 8.94116H13.5",
    stroke: "#E8E8E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 18.9412C13.79 18.9412 15.25 17.4812 15.25 15.6912C15.25 13.9012 13.79 12.4412 12 12.4412C10.21 12.4412 8.75 13.9012 8.75 15.6912C8.75 17.4812 10.21 18.9412 12 18.9412Z",
    stroke: "#E8E8E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9c977bd7c4db1a7486dc6bafd79d01ed.svg";
export { ForwardRef as ReactComponent };